import NumberFormat from 'react-number-format'
import cardChip from '../../assets/chip.png'
import tapIcon from '../../assets/tapSign.png'

export default function PaymentCard({
	cvvNumber,
	cardHolder,
	cardMonth,
	cardYear,
	bankIcon,
	cardNumber,
}) {
	return (
		<div className='flex flex-col border w-48 p-4 m-2 relative rounded-2xl h-80 bg-gray-800 text-gray-50 justify-center'>
			<div className='flex w-40 absolute items-start top-4 justify-between'>
				<img
					src={tapIcon}
					alt='tap'
					className='object-contain w-10 opacity-30'
				/>
				<img
					src={cardChip}
					alt='chip'
					className='object-contain w-10 rotate-90'
				/>
			</div>
			<div className='flex flex-col mt-16 text-sm'>
				{cardHolder ? <p>{cardHolder}</p> : <p>Card Holder</p>}
				{cardNumber ? (
					<NumberFormat
						displayType={'text'}
						format='#### #### #### ####'
						value={cardNumber}
					/>
				) : (
					<p>**** **** **** ****</p>
				)}
				<div className='flex text-xs justify-between'>
					<div>
						<p className='text-gray-500'>Exp Date</p>
						<p>
							{cardMonth ? cardMonth : 'MM'} /{' '}
							{cardYear ? cardYear.substring(2, 4) : 'YY'}
						</p>
					</div>
					<div>
						<p className='text-gray-500'>CVV</p>
						{cvvNumber ? <p>{cvvNumber}</p> : <p>***</p>}
					</div>
				</div>
			</div>
			<div
				className={`flex absolute bottom-4 right-4 p-1 rounded-md ${
					!bankIcon && 'bg-gray-400'
				} h-8 w-16`}>
				{bankIcon && (
					<img src={bankIcon} className='object-contain h-8 w-16' alt='logo' />
				)}
			</div>
		</div>
	)
}
